import { render, staticRenderFns } from "./disclaimer2.0.vue?vue&type=template&id=46f2833f&scoped=true&"
import script from "./disclaimer2.0.vue?vue&type=script&lang=js&"
export * from "./disclaimer2.0.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer2.0.vue?vue&type=style&index=0&id=46f2833f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2833f",
  null
  
)

export default component.exports